import {
    createPromoTileComponent,
    IPromoTileBusinessLogic,
    PromoTile,
    PromoTileCheckboxState,
} from '@vfde-brix/promo-tile';
import { TRADE_IN_PROMO_TILE_CONTAINER} from '../container/DeviceDetail/constants';
import { CLASSNAME_HIDDEN } from '@vfde-brix/core';

const mountPromoTile = (element: HTMLElement, business: IPromoTileBusinessLogic): PromoTile => {
    return createPromoTileComponent(element, business);
};

/**
 * Mount trade in promo tile
 */
export const mountTradeInPromoTile = (isTradeIn, isDisabled, isHidden, toggleTradeInAction): PromoTile => {
    const element = document.getElementById(TRADE_IN_PROMO_TILE_CONTAINER);

    if (element) {
        const promoTile = mountPromoTile(element, {
            onChange: (event) => {
                toggleTradeInAction();
            },
        });

        if (isHidden) {
            promoTile.hideContainer();
            promoTile.getContainerElement().previousElementSibling?.classList.add(CLASSNAME_HIDDEN);
        }

        promoTile.setCheckboxState({ checked: isTradeIn, disabled: isDisabled });

        if (isTradeIn) {
            promoTile.toggleCollapsibleState(isTradeIn);
        }

        return promoTile;
    }

    return undefined;
};

/**
 * Update promo tile
 * @param promoTile
 * @param checkboxState
 */
export const updatePromoTile = (promoTile: PromoTile, checkboxState: PromoTileCheckboxState) => {
    if (!promoTile) {
        return;
    }

    promoTile.setCheckboxState(checkboxState);

    if (checkboxState.disabled && checkboxState.checked) {
        promoTile.toggleCollapsibleState(true);
    }
};
